import {
    GetResponsibleList,
    DeleteResponsible,
    PostResponsible,
    GetResponsible,
    UpdateResponsible,
} from '@src/services/responsible'
import { GetStudentList, GetStudent } from '@src/services/student'
import { getSavedState } from '@src/utils/localStorage'
export const state = {
    responsibleList: [],
    studentList: [],
    studentFromForm: '',
}

export const getters = {
    totalList(state) {
        return state.responsibleList.data ?
            state.responsibleList.data.totalItemCount :
            0
    },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.responsibleList = newList
    },
    SET_STUDENT_LIST(state, newList) {
        state.studentList = newList
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((responsible) => {
            state.responsibleList.data.items.push(responsible)
        })
    },
    SET_STATUS(state, responsible) {
        state.responsibleList.data.list.items.find(({ publicId }) => {
            return publicId === responsible.publicId
        }).status = responsible.status
    },
    SET_STUDENT(state, student) {
        state.studentFromForm = student
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetResponsibleList(locationPublicId, parameters)
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
    },
    async getStudentsList({ commit }, parameters) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetStudentList(locationPublicId, parameters)
        if (resp.status === 200) {
            commit('SET_STUDENT_LIST', resp.data.data.list.items)
        }
    },
    async nextPage({ commit }, currentPage) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetResponsibleList(locationPublicId, currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
    async deleteResponsible({ dispatch }, responsible) {
        const resp = await DeleteResponsible(responsible)
        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async createResponsible({ _ }, responsibleMember) {
        responsibleMember.locationPublicId = getSavedState(
            'auth.selectedLocation'
        ).publicId
        const resp = await PostResponsible(responsibleMember)
        return resp
    },
    async setResponsibleForm({ _ }, responsible) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetResponsible(responsible, locationPublicId)
        return resp
    },
    async updateResponsible({ _ }, responsible) {
        responsible.locationPublicId = getSavedState(
            'auth.selectedLocation'
        ).publicId
        const resp = await UpdateResponsible(responsible)
        return resp
    },
    async setStudentFromResponsible({ commit }, student) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetStudent(student, locationPublicId)
        commit('SET_STUDENT', resp.data.data)
        return resp
    },
    removeStudentFromForm({ commit }) {
        commit('SET_STUDENT', null)
    },
}